import React from "react";

export const FexidocMark = ({ size = 28, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} data-testid="fexidoc-mark">
    <defs>
      <linearGradient id="fxg" x1="0" y1="0" x2="48" y2="48">
        <stop offset="0%" stopColor="#32D5FF" />
        <stop offset="55%" stopColor="#1478FF" />
        <stop offset="100%" stopColor="#725BFF" />
      </linearGradient>
      <filter id="fxglow" x="-30%" y="-30%" width="160%" height="160%">
        <feGaussianBlur stdDeviation="1.2" result="b" />
        <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
      </filter>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="12" fill="#0D1224" stroke="url(#fxg)" strokeWidth="1.2" />
    <g filter="url(#fxglow)" fill="url(#fxg)">
      <path d="M14 12h22c0 3.5-2.8 6.3-6.3 6.3H20v4h13c0 3.4-2.7 6.1-6.1 6.1H20v9h-6V12z" />
    </g>
  </svg>
);

export const FexidocLogo = ({ className = "", size = 28 }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="fexidoc-logo">
    <FexidocMark size={size} />
    <span className="font-display font-extrabold text-[17px] tracking-tight text-slate-100">Fexidoc</span>
  </div>
);
